module.exports = __webpack_public_path__ + "img/at.451957e3.svg";